import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {selectPostCategoryVisibility} from "../../../lib/PostUtils";
import PublishLayerHeader from "./PublishLayerHeader"
import PublishLayerFooter from "./PublishLayerFooter"
import PublishLayerBody from "./PublishLayerBody"
import {publishPost} from "../../../actions/post"


export default function PublishLayer({onClose}) {
  const post = useSelector(state => state.post.newPost)
  const postType = Config.postType
  const postCategoryVisibility = useSelector(state => selectPostCategoryVisibility(state.post.newPost, state.blog.categories))
  const dispatch = useDispatch()
  const needCaptcha = useSelector(state => state.post.needCaptcha);
  const captchaVerified = useSelector(state => state.post.captchaVerified);
  const draftSequence = useSelector(state => state.post.draftSequence);

  const [publishing, setPublishing] = useState(false)

  const verified = !needCaptcha || captchaVerified;

  function handlePublish(e) {
    e.preventDefault();

    if(!verified) {
      alert("'로봇이 아닙니다' 항목을 체크해 주세요.")
      return false;
    }else{
      dispatch(publishPost(
        post,
        postType,
        postCategoryVisibility,
        status => setPublishing(status),
        draftSequence
      ))
    }
  }

  return (
    <div className="inner_editor_layer inner_editor_layer1">
      <form action="#" onSubmit={handlePublish} onReset={onClose}>
        <fieldset>
          <legend className="screen_out">발행 정보입력 폼</legend>
          <PublishLayerHeader />
          <PublishLayerBody />
          <PublishLayerFooter publishing={publishing} visibility={post.visibility} />
        </fieldset>
      </form>
    </div>
  )
}
